import { Link } from "@tanstack/react-router";

import { useStationPage } from "../components/StationLayout";
import { recentTracks, relativeTime } from "../lib/stationStatus";

/** How many past tracks the tab lists. */
const RECENT_TRACK_COUNT = 5;

/** The station's default tab: what's on air, and the last few tracks. */
const RecentlyPlayed = () => {
  const { status, stationSlug } = useStationPage();
  const show = status.current_show;
  const tracks = recentTracks(status, RECENT_TRACK_COUNT);

  if (!show && tracks.length === 0) {
    return (
      <p className="station__quiet mono">
        Streaming live · no track info from this station
      </p>
    );
  }

  return (
    <section className="station__status" aria-live="polite">
      {show && (
        <div className="station__onair">
          <span className="eyebrow">
            <i className="live-dot" /> On air
          </span>
          <p className="station__show">
            {/* Externally-sourced shows have no page of their own. */}
            {show.slug ? (
              <Link
                to="/$stationSlug/shows/$showSlug"
                params={{ stationSlug, showSlug: show.slug }}
              >
                {show.name}
              </Link>
            ) : (
              show.name
            )}
          </p>
        </div>
      )}

      {tracks.length > 0 && (
        <div className="station__recent">
          <span className="eyebrow">Recently played</span>
          <ol className="station__tracks">
            {tracks.map(({ id, track, playedAt }) => (
              <li key={id}>
                <span className="station__track">
                  {track.name}
                  {track.artist && (
                    <span className="station__artist">
                      {" "}
                      — {track.artist.name}
                    </span>
                  )}
                </span>
                <span className="station__when mono">
                  {relativeTime(playedAt)}
                </span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </section>
  );
};

export default RecentlyPlayed;
